import { Component, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { DynamicFormComponent } from 'components/dynamic-form/dynamic-form.component';
import { filesExistAndValid } from '@certemy/ui-components';
import { DynamicFormField, DynamicFormSection } from 'interfaces/dynamic-form-field.interface';
import { constants } from 'constants/constants';
import { LogStepSupervisorType } from 'services/supervisor/supervisor.interface';
import { LogStepBaseMixin } from 'common/mixins/log-step-base.mixin';
import _get from 'lodash-es/get';

export enum LOG_STEP_TABS {
  SINGLE = 'SINGLE',
  MULTIPLE = 'MULTIPLE',
}

@Component({
  selector: 'cm-log-submit-tabs',
  templateUrl: './submit-tabs.component.html',
  styleUrls: ['./submit-tabs.component.scss'],
})
export class LogSubmitTabsComponent extends LogStepBaseMixin implements OnChanges {
  FIELD_TYPES = constants.FORM_FIELD_TYPE_IDS;
  readonly TABS = LOG_STEP_TABS;
  files: File[] = [];
  noFilesError = false;
  isFormView = false;
  noFileError = ['There are no files uploaded'];
  formFields: DynamicFormField[] = [];
  sections: DynamicFormSection[] = [];
  @Input() step: LogStepSupervisorType;
  @Input() hideMultipleTab: boolean;
  @Input() form;

  @Input() displayMessages = true;
  @Input() showErrors = false;
  @Input() disabled = false;
  @Input() activeTab: LOG_STEP_TABS;

  @Output() tabChange = new EventEmitter();

  @ViewChild(DynamicFormComponent) dynamicFormComponent: DynamicFormComponent;

  ngOnChanges(changes) {
    if (changes.form) {
      this.sections = this.form.sections;
      this.formFields = this.mapFields(this.form.fields, _get(this.step, 'content', {}), this.step?.step_type_id);
      this.isFormView = this.formFields.some((field) => field.type.id === this.FIELD_TYPES.ATTACHMENT);
    }
  }

  getForm() {
    return this.dynamicFormComponent;
  }

  getFormData(): { type: string; entryData: any } | void {
    let formData;
    if (this.activeTab === LOG_STEP_TABS.SINGLE) {
      formData = {
        type: LOG_STEP_TABS.SINGLE,
        entryData: this.dynamicFormComponent.getFormData(),
      };
    } else if (this.activeTab === LOG_STEP_TABS.MULTIPLE) {
      if (filesExistAndValid(this.files)) {
        formData = {
          type: LOG_STEP_TABS.MULTIPLE,
          entryData: {
            files: this.files,
          },
        };
        this.noFilesError = false;
      } else {
        this.noFilesError = true;
      }
    }

    return formData;
  }

  onFilesChange(files: File[]) {
    this.files = files;
  }

  onTabChange(event) {
    this.tabChange.emit(event);
  }
}
